<template>
    <div class="auth-layout">
        <div class="auth-layout--left-panel">
            <meta-logo />
            <socket-nav />
        </div>
        <div class="auth-layout--right-panel">
            <meta-auth-nav />
            <slot></slot>
        </div>
    </div>
</template>

<script>
import MetaLogo from '@partfactory/Shared/Header/MetaLogo';
import SocketNav from '@partfactory/Shared/Socket/SocketNav';
import MetaAuthNav from '@partfactory/Shared/Header/MetaAuthNav';
export default {
    name: 'AuthLayout',
    components: {
        MetaAuthNav,
        SocketNav,
        MetaLogo,
    }
};
</script>

